<template>
    <div>
        <editor :apiKey="apiKey" :init="innit" :value="model" @input="setModelData">
        </editor>
    </div>
</template>

<script>
    import Editor from "@tinymce/tinymce-vue";
    import Swal from "sweetalert";
    import {domain} from "../../util/Constants";
    import Service from "../../Services";

    export default {
        components: {Editor},
        name: "InputEditor",
        props: {
            model: "",
            id: ""
        },
        created() {
        },

        data() {
            return {
                apiKey: "dfsjfrd4yl1bw0v8157tap75tn6oo94azgqeemqtv3o2cayk",
                innit: {
                    height: 500,
                    plugins:
                        "lists advlist searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime wordcount imagetools textpattern emoticons",
                    toolbar:
                        "undo redo | bold italic underline | forecolor backcolor\
                        fontselect  fontsizeselect | fullscreen | alignleft aligncenter alignright alignjustify | \
                         outdent indent |  numlist bullist checklist |\
                        casechange permanentpen formatpainter removeformat |\
                        pagebreak \
                        insertfile image media pageembed link anchor |\
                    //     a11ycheck ltr rtl",
                    formats: {
                        // alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
                        // aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
                        // alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
                        // alignfull: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
                        // bold: { inline: 'span', classes: 'bold' },
                        // italic: { inline: 'span', classes: 'italic' },
                        // underline: { inline: 'span', classes: 'underline', exact: true },
                        // strikethrough: { inline: 'del' },
                        title_kanit26: { inline: 'span', styles: { color: '#2e8037', fontSize: '26px','font-family':'Poppins,Kanit', 'font-weight': 'bold' } },
                        sub_title_grey22: { inline: 'span', styles: { color: '#9E9E9E', fontSize: '22px','font-family':'Poppins,Kanit', 'font-weight': 'bold' } },
                        sub_title_green22: { inline: 'span', styles: { color: '#2e8037', fontSize: '22px','font-family':'Poppins,Kanit', 'font-weight': 'bold' } },
                        content_sarabun18: { inline: 'span', styles: { color: '#808080', fontSize: '18px','font-family':'Sarabun', 'font-weight': 'Normal' } },
                        sarabun_thin: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '100' } },
                        sarabun_extra_light: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '200' } },
                        sarabun_light: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '300' } },
                        sarabun_regular: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '400' } },
                        sarabun_medium: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '500' } },
                        sarabun_semi_bold: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '600' } },
                        sarabun_bold: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '700' } },
                        sarabun_extra_bold: { inline: 'span', styles: { 'font-family':'Sarabun', 'font-weight': '800' } },
                        kanit_thin: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '100' } },
                        kanit_extra_light: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '200' } },
                        kanit_light: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '300' } },
                        kanit_regular: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '400' } },
                        kanit_medium: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '500' } },
                        kanit_semi_bold: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '600' } },
                        kanit_bold: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '700' } },
                        kanit_extra_bold: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '800' } },
                        kanit_black: { inline: 'span', styles: { 'font-family':'Kanit', 'font-weight': '900' } },
                        poppins_thin: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '100' } },
                        poppins_extra_light: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '200' } },
                        poppins_light: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '300' } },
                        poppins_regular: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '400' } },
                        poppins_medium: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '500' } },
                        poppins_semi_bold: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '600' } },
                        poppins_bold: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '700' } },
                        poppins_extra_bold: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '800' } },
                        poppins_black: { inline: 'span', styles: { 'font-family':'Poppins', 'font-weight': '900' } },
                    },
                    style_formats: [
                        { title: 'Title Bold 26px', format: 'title_kanit26' },
                        { title: 'Sub Title Grey 22px', format: 'sub_title_grey22' },
                        { title: 'Sub Title Green 22px', format: 'sub_title_green22' },
                        { title: 'Content Normal 18px', format: 'content_sarabun18' },
                        { title: 'Sarabun Thin 100', format: 'sarabun_thin' },
                        { title: 'Sarabun Extra-light 200', format: 'sarabun_extra_light' },
                        { title: 'Sarabun Light 300', format: 'sarabun_light' },
                        { title: 'Sarabun Regular 400', format: 'sarabun_regular' },
                        { title: 'Sarabun Medium 500', format: 'sarabun_medium' },
                        { title: 'Sarabun Semi-bold 600', format: 'sarabun_semi_bold' },
                        { title: 'Sarabun bold 700', format: 'sarabun_bold' },
                        { title: 'Sarabun Extra-bold 800', format: 'sarabun_extra_bold' },
                        { title: 'Kanit Thin 100', format: 'kanit_thin' },
                        { title: 'Kanit Extra-light 200', format: 'kanit_extra_light' },
                        { title: 'Kanit Light 300', format: 'kanit_light' },
                        { title: 'Kanit Regular 400', format: 'kanit_regular' },
                        { title: 'Kanit Medium 500', format: 'kanit_medium' },
                        { title: 'Kanit Semi-bold 600', format: 'kanit_semi_bold' },
                        { title: 'Kanit bold 700', format: 'kanit_bold' },
                        { title: 'Kanit Extra-bold 800', format: 'kanit_extra_bold' },
                        { title: 'Kanit Black 900', format: 'kanit_black' },
                        { title: 'Poppins Thin 100', format: 'poppins_thin' },
                        { title: 'Poppins Extra-light 200', format: 'poppins_extra_light' },
                        { title: 'Poppins Light 300', format: 'poppins_light' },
                        { title: 'Poppins Regular 400', format: 'poppins_regular' },
                        { title: 'Poppins Medium 500', format: 'poppins_medium' },
                        { title: 'Poppins Semi-bold 600', format: 'poppins_semi_bold' },
                        { title: 'Poppins bold 700', format: 'poppins_bold' },
                        { title: 'Poppins Extra-bold 800', format: 'poppins_extra_bold' },
                        { title: 'Poppins Black 900', format: 'poppins_black' },
                        // { title: 'Align left', format: 'alignleft' },
                        // { title: 'Align center', format: 'aligncenter' },
                        // { title: 'Align right', format: 'alignright' },
                        // { title: 'Align full', format: 'alignfull' },
                        // { title: 'Bold text', inline: 'strong' },
                        // { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } },
                        // { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } },
                        { title: 'Badge', inline: 'span', styles: { display: 'inline-block', border: '1px solid #2e8037', 'border-radius': '5px', padding: '2px 5px', margin: '0 2px', color: '#2e8037' } },
                        // { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' },
                        // { title: 'Image formats' },
                        // { title: 'Image Left', selector: 'img', styles: { 'float': 'left', 'margin': '0 10px 0 10px' } },
                        // { title: 'Image Right', selector: 'img', styles: { 'float': 'right', 'margin': '0 0 10px 10px' } },
                    ],
                    // Fonts
                    fontsize_formats: "10px 12px 14px 16px 18px 22px 24px 36px",
                    content_style:
                        "@import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');" +
                        "@import url('https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');" +
                        "@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');" +
                        "body { font-family: 'Sarabun', sans-serif; } h1,h2,h3,h4,h5,h6 { font-family: 'Poppins','Kanit', sans-serif; }",
                    font_formats:
                        "Sarabun=sarabun; Kanit=kanit; Poppins=poppins; Arial Black=arial black,avant garde; Courier New=courier new,courier",
                    // Color
                    color_map: [
                        '000000', 'Black',
                        'FFFFFF', 'White',
                        'FF0000', 'Red',
                        'FFFF00', 'Yellow',
                        '0000FF', 'Blue',
                        '9E9E9E', 'Gray1',
                        '808080', 'Gray2',
                        '2e8037', 'TCDC Green',
                    ],

                    // enable title field in the Image dialog
                    image_title: true,
                    // enable automatic uploads of images represented by blob or data URIs
                    automatic_uploads: true,
                    // add custom filepicker only to Image dialog
                    file_picker_types: 'image',
                    convert_urls: false,
                    file_picker_callback: function (cb, value, meta) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            var file = this.files[0];
                            var reader = new FileReader();
                            reader.onload = function () {
                                console.log('onload')
                                var id = 'blobid' + (new Date()).getTime();
                                var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                                var base64 = reader.result.split(',')[1];
                                var blobInfo = blobCache.create(id, file, base64);
                                blobCache.add(blobInfo);

                                var fd = new FormData();
                                fd.append( 'file', file );
                                fd.append( 'file_name', file.name );

                                Service.UtilityAPI.getImageFilePath(fd).then(data => {
                                        cb(data.path, {title: file.name});
                                    }
                                );
                            };
                            reader.readAsDataURL(file);
                        };

                        input.click();
                    }
                }
            }
        },
        methods: {
            setModelData(val) {
                this.$emit("update", val);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "src/assets/css/variables.scss";

    .toolbar {
        background-color: white;
        /*border-radius: 30px;*/
    }
</style>
